
import { Vue, Component, toNative } from 'vue-facing-decorator';
import GroupsListView from './GroupsListView.vue';
import GroupSelections from './GroupSelections/GroupSelections.vue';
import { Root } from '@/main';

@Component({
  components: {
    GroupsListView,
    GroupSelections,
  },
})
class Groups extends Vue {
  // Tracks which tab is currently active
  private activeTab: 'groups' | 'groupselections' = 'groups';

  private mounted() {
    Root.emit('set-active-component', 'groups');
  }
}

export default toNative(Groups);
